import { CaretLeft, CaretRight } from "@phosphor-icons/react";

export const PAGE_SIZE = 50;

/** Simple prev/next pager — renders nothing when everything fits on one page. */
export function Pager({ page, total, pageSize = PAGE_SIZE, onChange, testId = "pager" }) {
  const pages = Math.max(1, Math.ceil(total / pageSize));
  if (pages <= 1) return null;
  const btn = "inline-flex items-center gap-1 rounded-md border border-border bg-card px-3 py-1.5 text-xs font-medium hover:bg-muted disabled:opacity-40";
  return (
    <div className="flex items-center justify-between gap-3 text-xs text-muted-foreground" data-testid={testId}>
      <span>{(page - 1) * pageSize + 1}–{Math.min(page * pageSize, total)} od {total}</span>
      <div className="flex items-center gap-2">
        <button className={btn} disabled={page <= 1} onClick={() => onChange(page - 1)} data-testid={`${testId}-prev`}><CaretLeft size={12} /> Novije</button>
        <span className="font-mono">{page}/{pages}</span>
        <button className={btn} disabled={page >= pages} onClick={() => onChange(page + 1)} data-testid={`${testId}-next`}>Starije <CaretRight size={12} /></button>
      </div>
    </div>
  );
}
